import { proxyClientOptions, RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { GetQuotesLogoParams, Logo } from '../../entities';
import { QuotesEnvironment } from '../../environment';
import { quotesLogosRoutes } from './routes';
import { QuotesLogosTransport } from './types';

const defaultLogoFields =
  'logo_light,logo_dark,logo_vector_light,logo_vector_dark,mark_light,mark_dark,mark_vector_light,mark_vector_dark,mark_composite_light,mark_composite_dark';

export class QuotesLogosRestful extends RestfulClient implements QuotesLogosTransport {
  constructor(session: Session) {
    const env = session.getEnvironment(QuotesEnvironment);
    super(env.logosUrl, session, { 'x-device-key': true }, proxyClientOptions(undefined, 'token'));
  }

  getQuotesLogos = async (symbols: string, params?: GetQuotesLogoParams): SafePromise<{ data: Logo[] }> => {
    const trimmedSymbols = typeof symbols === 'string' ? symbols.trim() : '';
    if (!trimmedSymbols) {
      return { ok: { data: [] } };
    }

    const env = this.session.getEnvironment(QuotesEnvironment);
    const path = this.routePath(quotesLogosRoutes.logos);
    const url = this.URL(
      path,
      this.withUpstreamCredentials(
        {
          composite_auto: true,
          fields: params?.fields ?? defaultLogoFields,
          scale: params?.scale ?? '60x60',
          search_keys: trimmedSymbols,
          search_keys_type: params?.search_keys_type ?? 'symbol',
        },
        { token: env.logosKey },
      ),
    );
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
